module.exports = __webpack_public_path__ + "static/6-1a5c6d8da570aad0bae16a1abb894ff4.jpg";